import { render, staticRenderFns } from "./contentRow.vue?vue&type=template&id=601020c2&"
import script from "./contentRow.vue?vue&type=script&lang=js&"
export * from "./contentRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports